import { createTheme } from "@mui/material/styles";

const walnut = "#2C2118";
const copper = "#C45C26";
const copperDark = "#9A3F16";
const cream = "#F4EDE3";
const ivory = "#FFF8F0";
const muted = "#8A7464";
const border = "#E6D5C3";

const headingFont = '"Literata", Georgia, "Times New Roman", serif';
const bodyFont = '"Source Sans 3", "Helvetica Neue", Arial, sans-serif';

const theme = createTheme({
  palette: {
    primary: {
      main: copper,
      dark: copperDark,
      contrastText: ivory,
    },
    secondary: {
      main: walnut,
    },
    background: {
      default: cream,
      paper: ivory,
    },
    text: {
      primary: walnut,
      secondary: muted,
    },
    divider: border,
  },
  typography: {
    fontFamily: bodyFont,
    h1: {
      fontFamily: headingFont,
      fontWeight: 600,
      fontSize: "clamp(2rem, 4vw, 2.75rem)",
      lineHeight: 1.2,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontFamily: headingFont,
      fontWeight: 600,
      fontSize: "1.5rem",
      lineHeight: 1.3,
    },
    h3: {
      fontFamily: headingFont,
      fontWeight: 600,
      fontSize: "1.1rem",
      lineHeight: 1.35,
    },
    body1: {
      fontSize: "1.05rem",
      lineHeight: 1.6,
    },
    button: {
      fontFamily: bodyFont,
      fontWeight: 600,
      textTransform: "none",
      letterSpacing: "0.01em",
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: cream,
          color: walnut,
        },
      },
    },
    MuiAppBar: {
      defaultProps: {
        color: "inherit",
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundColor: ivory,
          color: walnut,
          borderBottom: `1px solid ${border}`,
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: `1px solid ${border}`,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "8px 18px",
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
  },
});

export default theme;
